<template>
    <Modal :isOpen="isOpen" @close="handleClose">
        <DialogLayout @close="handleClose">
            <h3 class="Modal__title">{{ options.title }}</h3>
            <div>
                <div v-html="options.content">
                </div>
                <div class="d-flex justify-content-center text-center m-t-30">
                    <button v-if="!!options.button" type="button" class="Btn Btn--primary Btn--gradient Btn--shadow m-r-15"
                            @click="handleButton">
                        <span>{{ options.button.label }}</span>
                    </button>
                    <button type="button" class="Btn Btn--primary Btn--gradient Btn--shadow" @click="handleClose">
                        <span>Accéder au site</span>
                    </button>
                </div>
            </div>
        </DialogLayout>
    </Modal>
</template>

<script>
import Modal from "./Modal";
import DialogLayout from "./Layouts/DialogLayout";

export default {
    props: ['options'],
    components: {DialogLayout, Modal},
    data: function () {
        const isExclude = this.options.exclude_urls.includes(window.location.href.replace(/^\/|\/$/g, ''));
        return {
            isOpen: !isExclude && localStorage.getItem('informationsViewed') !== this.options.id
        }
    },
    mounted() {
        if (!!this.$props.options.seen_directly) {
            this.markAsSeen();
        }
    },
    methods: {
        handleClose: function () {
            this.isOpen = false;
            this.markAsSeen();
        },
        handleButton: function () {
            this.markAsSeen();
            window.location.href = this.$props.options.button.url;
        },
        markAsSeen: function () {
            localStorage.setItem('informationsViewed', this.$props.options.id);
        }
    }
}
</script>

<style scoped>
.modal-dialog {
    width: 100%;
    background: rgb(255, 255, 255);
    padding: 1.5rem 2rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-radius: 0.3rem;
    transition: 0.5s;
}

.modal-body {
    color: rgb(180, 180, 180);
}

.d-flex {
    display: flex;
}

.justify-content-center {
    justify-content: center;
}
</style>
